<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.details }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.detailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.bankId.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.bank }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="bankId"
                        :multiple="false"
                        :options="banks"
                        placeholder="Izaberite banku"
                      />

                      <form-error :model="$v.bankId" :label="translations.forms.labels.bank" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.companyId.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="companyId"
                        loadingText="Učitavanje..."
                        noResultsText="Nema rezultata"
                        searchPromptText="Unesite kompaniju"
                        :load-options="loadCompanies"
                        :async="true"
                        :options="companies"
                        :cache-options="false"
                        placeholder="Izaberite kompaniju"
                      />

                      <form-error :model="$v.companyId" :label="translations.forms.labels.company" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.bankAccount.$anyError }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.bankAccount }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.bankAccount"
                        v-model="bankAccount"
                      />

                      <form-error :model="$v.bankAccount" :label="translations.forms.labels.bankAccount" :dirty="$v.$dirty"/>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link exact :to="{ name: 'Currencies' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import api from '@/services/api';
import { translations } from '@/mixins';
import validations from './valdation-schema/add';
import FormError from '@/components/shared/form-errors/FormError.vue';

export default {
  name: 'AddBank',
  mixins: [translations],
  validations,
  components: { FormError, Treeselect },
  computed: {
    companies() {
      return this.$store.getters.getCompanies.map((item) => {
        return {
          label: item.title,
          id: item.id,
        }
      });
    },
    banks() {
      return this.$store.getters.getBanks.map((item) => {
        return {
          label: item.title,
          id: item.id,
        }
      });
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  data() {
    return {
      bankAccount: '',
      bankId: null,
      companyId: null
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { bankAccount, bankId, companyId } = this;
      
      api
        .createCustomerBankAccount({ bankAccount, bankId, companyId })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'CustomerBankAccounts' });
        });
    },
    loadCompanies({ callback, searchQuery }) {
      this.$store
        .dispatch('getCompanies', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.companies);
        });
    },
  },
  mounted() {
    this.$store.dispatch('getCompanies', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getBanks', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
};
</script>

<style lang="scss" scoped>
.vue-treeselect__placeholder {
  color: #000;
}

.vue-treeselect__placeholder,
.vue-treeselect__single-value {
  line-height: 55px !important;
}

.vue-treeselect__control {
  height: 55px !important;
  font-size: 0.85rem;
}
</style>